import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { MediaQuery as MQ } from '../../shared/media-query';
import { img_width_height } from '../../shared/util';
import { v4 as uuidv4 } from 'uuid';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.uuid = uuidv4();

        const tags = props.tags ? props.tags.split(',').map(tag => tag.trim()) : null;

        props.requirePromoMessage(this.uuid, props.placement, tags);
    }

    shouldComponentUpdate(nextProps) {
        if (
            nextProps.messages != this.props.messages
            &&
            nextProps.messages[this.uuid]
            &&
            nextProps.messages[this.uuid] != this.props.messages[this.uuid]
        ) {
            return true;
        }

        if (nextProps.logged_in != this.props.logged_in) {
            return true;
        }

        if (nextProps.promoPageViews != this.props.promoPageViews) {
            return true;
        }

        if (nextProps.report_id != this.props.report_id) {
            return true;
        }

        return false;
    }

    render({ messages, placement, tags, mode, class: className }) {
        const doRender = placement == 'sidebar' && (MQ.isMobile() || MQ.isTabletPortrait()) ? false : true;

        if (messages && messages[this.uuid] && messages[this.uuid].message && doRender) {
            if (!this.props.hasOwnProperty('no-impression')) {
                this.trackImpression();
            }

            let message = this.props.messages[this.uuid].message.replace(/\r\n|\n|\r|\t/gm, '');

            message = this.messageTransform(message);

            return (
                <promo-message
                    uuid={this.uuid}
                    dangerouslySetInnerHTML={{__html: message}}
                    onClick={this.trackClick}
                    placement={placement}
                    tags={tags}
                    mode={mode}
                    className={className}
                    no-impression={this.props['no-impression']}
                />
            );
        }

        return (
            <promo-message
                placement={placement}
                tags={tags}
                uuid={this.uuid}
                mode={mode}
                className={className}
                no-impression={this.props['no-impression']}
            />
        );
    }

    messageTransform = (message) => {
        if ((this.props.placement == 'in-product' || this.props.placement == 'free-reading-upsell')
            && message.match(/\{report_ID\}/) && this.props.report_id
        ) {
            message = message.replace(/\{report_ID\}/g, this.props.report_id);
        } else if (this.props.placement == 'tarot-page' && message.match(/\{card/) || message.match(/\{deck/)) {
            const card = this.props.card || { name: 'The Fool', the_name: 'The Fool'};
            const deck = this.props.deck || {
                name: 'Universal Waite',
                stripped_name: 'Universal Waite',
                slug: 'universal-waite',
            };

            message = message.replace(/\{card.name\}/g, card.name);
            message = message.replace(/\{card.the_name\}/g, card.the_name);
            message = message.replace(/\{deck.name\}/g, deck.name);
            message = message.replace(/\{deck.stripped_name\}/g, deck.stripped_name);
            message = message.replace(/\{deck.slug\}/g, deck.slug);
        } else if (
            this.props.placement == 'text-vip-message'
            ||
            this.props.placement == 'text-catalog'
            ||
            this.props.placement == 'text-checkout'
        ) {
            message = `<p>${message}</p>`;
        } else if (this.props.placement == 'sidebar' || this.props.placement =='psychic-nav-article') {
            message = this.updateLazyImg(message);
        }

        return message;
    }

    updateLazyImg = (message) => {
        if (!message.includes('lazyload')) {
            const img_tag = message.split(/(?=<)/).filter(tag => tag.substring(0, 4) == '<img')[0];
            const img_url = img_tag.split(' ').filter(tag => tag.startsWith('src'))[0].split(/['"]/).slice(-2)[0];
            let new_img_tag = img_tag.replace('src', 'data-src');
            let class_attribute = '';

            if (img_tag.includes('class')) {
                new_img_tag = new_img_tag.replace('class="', 'class="lazyload ');
            } else {
                class_attribute = ' class="lazyload"';
            }

            new_img_tag = [
                new_img_tag.slice(0, 5),
                `${class_attribute} width=${img_width_height(img_url)[0]} height=${img_width_height(img_url)[1]} `,
                new_img_tag.slice(5),
            ].join('');
            message = message.replace(img_tag, new_img_tag);
        }

        return message;
    }

    trackClick = () => {
        const category = this.props.placement + ' promo message';
        const action = this.props.logged_in ? 'LI Click' : 'LO Click';
        const label = this.props.messages[this.uuid].code;

        this.props.trackEvent([category, action, label]);
        this.props.trackPromo([category, label]);
    }

    trackImpression = () => {
        const action = this.props.logged_in ? 'LI Impression' : 'LO Impression';
        const label = this.props.messages[this.uuid].code;

        this.props.trackEvent([`${this.props.placement} promo message`, action, label]);
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    messages: state['promo-message'],
    promoPageViews: state.cookie && state.cookie.promo_page_views,
    report_id: state.report && state.report.constants && state.report.constants.product_slug,
    deck: state.deck,
    card: state.card,
});

const mapDispatchToProps = (dispatch) => ({
    requirePromoMessage: (uuid, placement, tags) => dispatch({ type: 'promo-message:require', payload: {
        uuid: uuid,
        placement: placement,
        tags: tags,
    }}),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    trackPromo: (payload) => dispatch({ type: 'promo-tracker:recordInternal', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
